
import GDialog from '@/common/components/g-dialog/index.vue'
import { parseTime } from '@/common/utils/Date.js'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import GHeader from '@/common/components/g-header/index.vue'
import noData from '@/common/components/noData/index.vue'
import { getMyYEBList, redeemYEB } from '@/common/api/YuEBao.js'
import loadmorelistMx from '@/common/mixin/loadmorelist.js'
import GCountDown from '@/common/components/g-count-down/'
import loadMore from '@/common/components/load-more/index.vue'
export default {
components: { GCountDown,loadMore,noData,Tab,TabItem,GHeader,GDialog},
mixins: [loadmorelistMx(getMyYEBList), false],
data() {
return {
show:false,
query:{},
tabList: {
going: 'mine.yuerbao.processing',
finish: 'mine.yuerbao.completed'
},
statusType: 'going' 
}
},
filters: {
parseTimeFilter(time) { return parseTime(time) },
},
created() {

const { isApp, UUID, curTab } = this.$route.query
if (isApp && UUID && curTab) this.statusType = this.$route.query.curTab === '0' ? 'going' : 'finish'
this.handleFetch()
},
methods: {
onItemClick(v) {
this.statusType = v
this.pages.pageNo = 1
this.handleFetch()
},
handleCanacl(){ this.show = false },
handleSure(){
redeemYEB(this.query).then(([data, err]) => {
if (!err) {
this.$vux.toast.show({ text: `${this.$t('mine.yuerbao.chanping')} ${this.query.bonusName} ${this.$t('mine.yuerbao.successful')}!`, type: 'success' })
this.pages.pageNo = 1
this.handleFetch()
} else {
this.$vux.toast.show({ text: err.message, type: 'warn' })
}
this.handleCanacl()
})
},
handleRedeem({ bonusName,id }) { // 赎回
this.show = true
this.query = { UUID: this.$store.state.UUID, logId: id,bonusName }
},
implementationFetched([data, err, res]) {
if (!err) {
const { curTime, pageData } = data
const { total, list } = pageData
this.total = total
if (this.pages.pageNo === 1) this.list = []
list.forEach((item) => {
const { createTime, schemeCycle, maxRateAmount, rateAmount } = item
const profit = maxRateAmount > 0 ? (maxRateAmount - rateAmount).toFixed(2) : null
const t1 = parseInt((createTime * 1 + (schemeCycle * 3600 * 1000) - curTime) / 1000)
this.list.push({ ...item, countDownTime: t1 > 0 ? t1 : 0, profit })
})
} else {
if (this.pages.pageNo === 1) {
this.total = 0
this.list = []
}
}
},

getparams() { // 获取参数
let params = { status: this.statusType }
if (this.$Cookies.get('UUID')) params.UUID = this.$Cookies.get('UUID')
return params
}
}
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/yu-e-bao/index.vue